import React, { useCallback, useEffect } from 'react';
import { getBetaEnvironmentInfo } from 'utils/getBetaEnvironment';
import { useStoreSelector } from 'v3/data/store';
import { showBetaAccessErrorDialog } from 'v3/data/store/error/actions';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { ContractingListPage } from 'v3/pages/Contracting/List';
import { OnlineContractingListPage } from 'v3/pages/OnlineContracting/List';
import * as api from 'v3/services/api';
import { FeatureFlagEnum } from 'v3/shared/enums/feature-flag.enum';

export const SplashPage = () => {
  const { group, storeUserId } = useStoreSelector((store) => store.store.storeLogged);
  const isOnlineProfile
    = group === StoreProfileEnum.IN_APP
    || group === StoreProfileEnum.LOM
    || group === StoreProfileEnum.ONLINE;

  const fetchFeatureFlags = useCallback(async () => {
    try {
      await verifyBetaEnvAuthorization();
    } catch (error) {
      console.error('Error fetching feature flags:', error);
    }
  }, []);

  const verifyBetaEnvAuthorization = async () => {
    const isBeta = getBetaEnvironmentInfo();
    if (!isBeta) return;
    try {
      const response = await api.getFlagStatus(FeatureFlagEnum.IS_BETA_STORE);
      if (response.data.enabled) return;
      showBetaAccessErrorDialog();
    } catch (error) {
      console.error('Error fetching beta feature flags:', error);
    }
  };

  useEffect(() => {
    fetchFeatureFlags();
  }, []);

  const ComponentToRender = storeUserId ? 
    isOnlineProfile ? 
      <OnlineContractingListPage />
      :       <ContractingListPage />
    
    : null;

  return ComponentToRender;
};
